module.exports = __webpack_public_path__ + "img/logo-google-webdev.1efe3ee5.svg";